import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const STORAGE_KEY = 'verilock_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch (e) {
      // Privacy mode / disabled storage — show the banner anyway.
      setVisible(true);
    }
  }, []);

  const persist = (choice) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (e) {
      // ignore — banner just won't remember next visit
    }
    if (choice === 'declined' && window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
      window.posthog.opt_out_capturing();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
      className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 sm:px-6 sm:pb-6"
    >
      <div className="max-w-4xl mx-auto bg-white border border-[#e0ddd8] rounded-2xl shadow-lg p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <p className="text-sm text-[#1a1a1a]/80 leading-relaxed">
          We use essential cookies to make Verilock work and minimal analytics to
          improve the product. See our{' '}
          <Link to="/privacy" className="text-[#0a5c44] underline hover:no-underline">
            privacy policy
          </Link>
          .
        </p>
        <div className="flex gap-2 sm:gap-3 shrink-0">
          <Button
            variant="outline"
            data-testid="cookie-consent-decline-button"
            onClick={() => persist('declined')}
            className="border-[#e0ddd8] text-[#1a1a1a] hover:bg-[#f5f3ef] h-11 px-4 sm:px-5 flex-1 sm:flex-none"
          >
            Decline
          </Button>
          <Button
            data-testid="cookie-consent-accept-button"
            onClick={() => persist('accepted')}
            className="bg-[#0a5c44] text-white hover:bg-[#0a5c44]/90 transition-colors h-11 px-4 sm:px-5 flex-1 sm:flex-none"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
